import { string, ref, boolean } from 'yup';

export const email = string()
  .required('Email is required')
  .email('Provide a valid email address');

export const username = string()
  .required('Username is required')
  .matches(/^[a-zA-Z0-9-_.]+$/, {
    message: 'May include latin letters, numbers and symbols "_", "-" or "."',
  });

export const password = string()
  .required('Password is required')
  .min(8, 'At least 8 characters');

export const confirmPassword = string()
  .required('Confirm password is required')
  .oneOf([ref('password'), ''], 'Passwords do not match');

export const agreeWithTS = boolean()
  .required()
  .oneOf([true], 'The terms and conditions must be accepted');

export const verificationCode = string().required(
  'Verification code is required',
);
